import { useQueryClient } from '@tanstack/react-query';

import { useEditUserDetailInfoQuery } from './query';
import toastMsg from '../../../../../lib/toastMsg';
import accountUserToastMsg from '../../../../../constants/service/toastMsg/accountUserToastMsg';
import { USER_DETAIL_QUERY_KEYS } from '../common/queryKeys';

export const useEditUserDetailInfo = ({ userId }) => {
  const queryClient = useQueryClient();

  const { editUserDetailInfoMutate } = useEditUserDetailInfoQuery({
    userId,
    options: {
      onSuccess: () => toastMsg.success(accountUserToastMsg.EDIT_USER_DETAIL_REQUEST_SUCCESS),
      onError: (error) => toastMsg.error(error.message),
    },
  });

  //유저 정보 편집 후 기존에 불러왔던 유저 상세 데이터 재요청
  const editUserDetailInfo = async (payload) => {
    await editUserDetailInfoMutate(payload);

    queryClient.invalidateQueries([...USER_DETAIL_QUERY_KEYS.USER_INFO_V2]);
  };

  return { editUserDetailInfo };
};
